import { render, staticRenderFns } from "./BenefitsMkRu.vue?vue&type=template&id=9627e520"
import script from "./BenefitsMkRu.vue?vue&type=script&lang=js"
export * from "./BenefitsMkRu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports